import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

import PaginatorSkeleton from "../skeleton/PaginatorSkeleton";
import { handleSubmit } from "../../../../auxiliar/auxFunctions";
import { isDefined } from "../../../../auxiliar/formatValidators";

const PaginatorComponent = ({ pagination, filter, setFilter, disabled, showTotalItems = true }) => {
    if (!isDefined(pagination?.total_items)) {
        return <PaginatorSkeleton showTotalItems={showTotalItems} />;
    }

    if (!pagination || (!pagination.has_next && !pagination.has_prev)) {
        if (showTotalItems) {
            return (
                <div className="flex items-center gap-1 sm:gap-2 h-8 sm:justify-end">
                    <div className="text-xs text-base-content/50 ml-2">
                        {pagination?.total_items}{" "}
                        {pagination?.total_items === 1 ? "elemento" : "elementos"}
                    </div>
                </div>
            );
        } else {
            return <div></div>;
        }
    }

    return (
        <div
            className={`flex items-center gap-1 sm:gap-2 h-8 ${showTotalItems ? "justify-between sm:justify-end" : "justify-end"}`}
        >
            {/* Show total items for context or empty placeholder */}
            {pagination.total_items && showTotalItems ? (
                <div className="text-xs text-base-content/50 ml-2">
                    {pagination.total_items}{" "}
                    {pagination.total_items === 1 ? "elemento" : "elementos"}
                </div>
            ) : (
                <div></div>
            )}

            <div className="flex items-center gap-1 sm:gap-2">
                {/* Previous button */}
                <button
                    className="btn btn-ghost btn-sm sm:btn-sm px-2 sm:px-3 text-base-content/70 hover:text-base-content hover:bg-base-200 disabled:text-base-content/30"
                    onClick={handleSubmit(setFilter, {
                        ...filter,
                        page: pagination.curr_page - 1,
                    })}
                    disabled={!pagination.has_prev || disabled}
                    aria-label="Página anterior"
                >
                    <FontAwesomeIcon icon={faChevronLeft} className="w-3 h-3" />
                </button>

                {/* Page info */}
                <div className="px-3 sm:px-4 py-1 text-sm text-base-content/70 bg-base-200 rounded-md border border-base-300 text-center flex items-center justify-center">
                    <span className="font-medium text-base-content">{pagination.curr_page}</span>
                    <span className="mx-1">/</span>
                    <span>{pagination.max_pages}</span>
                </div>

                {/* Next button */}
                <button
                    className="btn btn-ghost btn-sm sm:btn-sm px-2 sm:px-3 text-base-content/70 hover:text-base-content hover:bg-base-200 disabled:text-base-content/30"
                    onClick={handleSubmit(setFilter, {
                        ...filter,
                        page: pagination.curr_page + 1,
                    })}
                    disabled={!pagination.has_next || disabled}
                    aria-label="Página siguiente"
                >
                    <FontAwesomeIcon icon={faChevronRight} className="w-3 h-3" />
                </button>
            </div>
        </div>
    );
};

export default PaginatorComponent;
